import { IHolidayFormFilter } from "../types";
import { FormAutocomplete, FormNumberInput } from "../../common/form-fields-wrappers";
import { useTranslation } from "react-i18next";
import { HOLIDAY_FILTER_DEFAULTS } from "./const";
import { useTheme } from "@mui/material/styles";
import { useContext, useEffect, useMemo } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { SearchRounded } from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import { UseFormReturn } from "react-hook-form";

function HolidayFilter(props: {
    form: UseFormReturn<IHolidayFormFilter, any>,
    onSearch: () => void,
}) {
    const theme = useTheme();
    const {t} = useTranslation(['network', 'translation']);
    const { globalData } = useContext(GlobalContext);

    const isOperator = globalData?.user?.operatorType === 2;

    const tenants = useMemo<string[]>(() => {
        return globalData?.user.legalEntities?.map((elem: any) => elem.name) || [];
    }, [globalData]);

    useEffect(() => {
        if (tenants.length === 1) {
            props.form.setValue("tenants", tenants);
        }
    }, [tenants])

    return (
        <Stack direction="row" alignItems="center" justifyContent="end" columnGap={2}>
            <Box width={200}>
                <FormNumberInput<IHolidayFormFilter>
                    name='year'
                    control={props.form.control}
                    label={t("msHoliday.fields.year")}
                    minValue={HOLIDAY_FILTER_DEFAULTS.year}
                    maxValue={HOLIDAY_FILTER_DEFAULTS.year + 10}
                />
            </Box>
            {tenants.length > 1 &&
                <Box width={200}>
                    <FormAutocomplete<IHolidayFormFilter>
                        name='tenants'
                        control={props.form.control}
                        label={t("msHoliday.fields.nation")}
                        options={tenants}
                        getOptionLabel={(opt) => opt && t(`msHoliday.legalEntities.${opt}`)}
                        onChange={(_, value) => props.form.setValue("tenants", value ? [value] : null)}
                        required
                    />
                </Box>
            }
            <Tooltip title={t('msHoliday.labels.search')}>
                <Button
                    size="icon"
                    color="accent"
                    onClick={props.onSearch}
                >
                    <SearchRounded/>
                </Button>
            </Tooltip>
        </Stack>
    )
}

export default HolidayFilter;